import { encodeParam } from './params.utils';
import { simplifyUrl } from './urlInterceptor.utils';

export function resolvePathWithSavedParams(to, getSessionKeyData) {
  let pathname = typeof to === 'string' ? to : to.pathname;
  pathname = encodeURI(decodeURI(pathname));
  let [basePath, queryString] = pathname.split('?');
  let key = simplifyUrl({ pathname: basePath });

  switch (key) {
    case '/assets/Cryptography':
      key = key + '&Certificates';
      basePath = basePath + '/Certificates';
      break;
    case '/assets/Credentials':
      key = key + '&User%20Accounts';
      basePath = basePath + '/User%20Accounts';
      break;
  }

  const savedParams = getSessionKeyData(key);

  if (!queryString && savedParams) {
    const restoredQuery = new URLSearchParams();
    Object.keys(savedParams).forEach(k => {
      restoredQuery.append(k, encodeParam(savedParams[k]));
    });
    return `${basePath}?${restoredQuery.toString()}`;
  }

  return pathname;
}
